<template>
  <a-modal
    :visible="visible"
    :title="title"
    @cancel="handleCancel"
    width="500px"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('直播课程.课程')" prop="courseId">
        <a-select v-model="form.courseId">
          <a-select-option v-for="item in courseList" :key="item.id" :value="item.id">
            {{ item.courseTitle }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.章节数')" prop="chapterNumber">
        <a-input-number v-model="form.chapterNumber" :min="1" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.章节名称')" prop="chapterName">
        <a-input v-model="form.chapterName" :maxLength="255" />
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button @click="handleCancel">{{$t('通用.按钮.取消')}}</a-button>
      <a-button type="primary" @click="submitForm">{{$t('通用.按钮.确定')}}</a-button>
    </template>
  </a-modal>
</template>

<script>
import { addLiveCourseChapter, updateLiveCourseChapter } from '@/api/livecourse/liveCourseChapter'

export default {
  name: 'CreateForm',
  props: {
    courseList: {
      type: Array,
      default: () => []
    },
    courseId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      visible: false,
      title: '',
      form: {
        id: undefined,
        courseId: undefined,
        chapterNumber: undefined,
        chapterName: undefined
      },
      rules: {
        courseId: [{ required: true, message: '请选择课程', trigger: 'change' }],
        chapterNumber: [{ required: true, message: '请输入章节数', trigger: 'blur' }],
        chapterName: [{ required: true, message: '请输入章节名称', trigger: 'blur' }]
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 16 }
    }
  },
  methods: {
    handleAdd() {
      this.title = '新增章节'
      this.form = {
        id: undefined,
        courseId: this.courseId,
        chapterNumber: undefined,
        chapterName: undefined
      }
      this.visible = true
    },
    handleUpdate(row) {
      this.title = '修改章节'
      this.form = { ...row }
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            updateLiveCourseChapter(this.form).then(() => {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('ok')
            })
          } else {
            addLiveCourseChapter(this.form).then(() => {
              this.$message.success('新增成功')
              this.visible = false
              this.$emit('ok')
            })
          }
        }
      })
    }
  }
}
</script>